import { tool, zodSchema } from 'ai';
import { z } from 'zod';
import type { AiTool } from '@erikdakoda/ai-tool/types';
import { botsToolGroupIcon } from './toolGroupIcon';
import { ormToolQueryArgsSchema } from '@erikdakoda/ai-tool/types';
import { BotForAiToolsSchema } from './BotForAiTools';
import { createBotSelectSchema } from './botAiToolInputSchemas';

const botUpdateBodySchema = BotForAiToolsSchema.omit({
  id: true,
  ownerId: true,
  spaceId: true,
  slug: true,
  createdAt: true,
  updatedAt: true,
}).partial();

export const updateBotInputSchema = z.object({
  botId: z.string(),
  bot: botUpdateBodySchema.describe(
    'Fields to change, including optional `publishedAt` (set a date to publish, null to unpublish).',
  ),
  select: createBotSelectSchema,
});

export const updateBotOutputSchema = z.object({
  queryArgs: ormToolQueryArgsSchema,
  queryResult: BotForAiToolsSchema.partial()
    .nullable()
    .optional()
    .describe('Updated bot; returns all fields when `select` is omitted.'),
  success: z.string().nullable(),
  error: z.unknown().nullable(),
});

export type UpdateBotInput = z.infer<typeof updateBotInputSchema>;
export type UpdateBotOutput = z.infer<typeof updateBotOutputSchema>;

export const updateBot: AiTool<undefined, UpdateBotInput, UpdateBotOutput> = {
  id: 'updateBot',

  group: 'bots',

  ...botsToolGroupIcon,

  userSelect: false,

  access: 'WRITE',

  tool: tool({
    description: 'Update an existing bot by id.',
    inputSchema: zodSchema(updateBotInputSchema),
    outputSchema: zodSchema(updateBotOutputSchema),
  }),
};
